import React from "react";
import { Options, ToggleSidebar, useCharity, Link, ToggleSmallShow } from "@";
import AddMenu from "@/shared/components/navBar/AddMenu";

const NavBar = () => {
  const { charityName, charityLogo, isLoading } = useCharity();

  return (
    <nav
      className=" navbar lg:ms-[250px] lg:w-[calc(100%-250px)]  fixed inset-x-0 top-0 z-[44] border-b border-gray-100 dark:border-gray-700 bg-white/85 dark:bg-gray-900/85 backdrop-blur-md text-gray-900 dark:text-gray-100 shadow-sm shadow-purple-900/5 print:hidden"
      dir="rtl"
    > 

      <ToggleSmallShow />

      <div className="relative flex h-[65px] items-center justify-between gap-3 px-3 lg:px-5">
        {/* Right cluster — brand + welcome */}
        <div className="flex min-w-0 items-center gap-3">
          {/* Mobile-only sidebar toggle */}
          <div className="lg:hidden">
            <ToggleSidebar />
          </div>

          {/* Logo chip — visible on mobile, hidden on desktop (sidebar shows it) */}
          {isLoading ? (
            <span className="block h-10 w-10 animate-pulse rounded-2xl bg-white/10 dark:bg-gray-700" />
          ) : (
            <Link
              to="/"
              className="inline-flex lg:hidden md:h-14 md:w-14 h-12 w-12 items-center justify-center rounded-2xl bg-white dark:bg-gray-900 p-1 ring-1 ring-purple-100 dark:ring-gray-900 transition-transform hover:scale-105"
            >
              <img
                width={64}
                height={64}
                src={charityLogo}
                alt={charityName}
                className="h-full w-full rounded-lg object-contain"
              />
            </Link>
          )}

          {/* Welcome text — desktop only */}
          <div className="hidden min-w-0 items-center gap-3 lg:flex">
            <span
              aria-hidden
              className="h-9 w-1 rounded-full bg-gradient-to-b from-purple-700 to-purple-950"
            />
            <div className="min-w-0">
              <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-purple-700">
                أهلاً مجدداً
              </p>
              <h1 className="-mt-0.5 truncate text-[15px] font-bold tracking-tight text-gray-900 dark:text-gray-300">
                {isLoading ? (
                  <span className="block h-4 w-40 animate-pulse rounded bg-gray-100 dark:bg-gray-700" />
                ) : (
                  charityName
                )}
              </h1>
            </div>
          </div>
        </div>

        {/* Left cluster — actions */}
        <div className="flex items-center gap-2 sm:gap-2.5">
          <AddMenu />
          <Options />
        </div>
      </div>
    </nav>
  );
};

export default React.memo(NavBar);
